import { FC } from 'react';
import { RequestDetailsViewProvider } from '../../hooks/use-request-details-view';
import { RequestDetailsView } from './request-details';

export interface RequestDetailsViewWithProviderProps {
  apptRequestId: number;
}

export const RequestDetailsViewWithProvider: FC<RequestDetailsViewWithProviderProps> = (props) => {
  return (
    <RequestDetailsViewProvider apptRequestId={props.apptRequestId}>
      <RequestDetailsView />
    </RequestDetailsViewProvider>
  );
};
